(() => {
  const storageKey = 'jinmere_cookie_consent_v1';
  const banner = document.querySelector('[data-jm-cookie-banner]');
  const settingsFor = (choice) => ({
    ad_storage: choice === 'accepted' ? 'granted' : 'denied',
    analytics_storage: choice === 'accepted' ? 'granted' : 'denied',
    ad_user_data: choice === 'accepted' ? 'granted' : 'denied',
    ad_personalization: choice === 'accepted' ? 'granted' : 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
  });

  const updateGoogleConsent = (choice) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('consent', 'update', settingsFor(choice));
  };

  let savedChoice = null;
  try { savedChoice = window.localStorage.getItem(storageKey); } catch (_) { /* Storage may be unavailable. */ }
  if (savedChoice === 'accepted' || savedChoice === 'rejected') {
    updateGoogleConsent(savedChoice);
    if (banner) banner.hidden = true;
  }

  document.querySelectorAll('[data-jm-consent]').forEach((button) => {
    button.addEventListener('click', () => {
      const choice = button.dataset.jmConsent;
      try { window.localStorage.setItem(storageKey, choice); } catch (_) { /* The choice still applies for this visit. */ }
      updateGoogleConsent(choice);
      if (banner) banner.hidden = true;
    });
  });
})();
